import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import store from '../../../@store'
import service from '../../../@services'
const { Option } = Select
/**
 *
 * @param {Boolean} isString (默认false:返回数组，true:返回字符串)
 * @param {Object} value 选择值
 * @param {Function} onChange 选择框的值改变的方法
 * @param {Function} onOptionLoad 初始化选择默认值的方法，返回默认值
 * @param {Array} storeList 门店列表（store）
 * @param {String} storeCode 默认门店code（store）
 * @param {Boolean} allowClear (默认false:不可清空)
 * @returns
 */
const SelectStores = ({
  storeList,
  storeCode,
  style = {},
  value,
  onChange,
  isString,
  onOptionLoad = () => {},
  allowClear = false,
}) => {
  useEffect(() => {
    if (!storeList) {
      service.common.getStoreList()
    } else {
      const _defaultStore =
        (
          storeList.filter((item) => item.storeCode == storeCode)[0] ||
          storeList[0] ||
          {}
        ).storeCode || null
      onOptionLoad && onOptionLoad(_defaultStore)
    }
    return () => {}
  }, [storeList])
  const _onChange = (val) => {
    store.dispatch({ type: 'common/storeCode', payload: val })
    onChange && onChange(isString ? val : [val])
  }
  return (
    <Select
      value={value}
      placeholder="全部"
      showSearch
      allowClear={allowClear}
      style={{ width: '200px', ...style }}
      onChange={_onChange}
      optionFilterProp="children"
    >
      {storeList &&
        storeList.map((item) => (
          <Option value={item.storeCode} key={item.storeCode}>
            {item.storeName}
          </Option>
        ))}
    </Select>
  )
}
export default connect((state) => ({
  storeList: state.common.storeList,
  storeCode: state.common.storeCode,
}))(SelectStores)
